var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ff9494",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M495.137,245.057h-16.684v-27.807c0-27.599-22.453-50.052-50.052-50.052h-0.611 c28.879-51.678,22.021-116.479-20.588-161.915C396.898-5.708,378.35,1.589,378.35,16.696c0,34.628-25.946,50.4-50.052,50.4 H217.071c-58.733,0-107.47,43.582-115.591,100.104H83.6c-27.599,0-50.052,22.453-50.052,50.052v27.807H16.864 c-9.214,0-16.684,7.47-16.684,16.684v166.839c0,45.998,37.422,83.42,83.42,83.42h344.801c45.998,0,83.42-37.422,83.42-83.42 V261.742C511.821,252.527,504.351,245.057,495.137,245.057z M217.071,100.463h111.226c31.126,0,59.805-15.638,74.056-43.437 c16.408,35.852,11.46,78.312-14.85,110.173H135.328C143.079,129.171,176.786,100.463,217.071,100.463z M66.916,217.251 L66.916,217.251c0-9.2,7.484-16.684,16.684-16.684c10.106,0,336.397,0,344.801,0c9.2,0,16.684,7.484,16.684,16.684v27.807H66.916 V217.251z M478.453,428.581c0,27.599-22.453,50.052-50.052,50.052H83.6c-27.599,0-50.052-22.453-50.052-50.052V278.425 c11.456,0,433.356,0,444.905,0V428.581z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M378.35,311.793H133.652c-27.599,0-50.052,22.453-50.052,50.052v33.368c0,27.599,22.453,50.052,50.052,50.052H378.35 c27.599,0,50.052-22.453,50.052-50.052v-33.368C428.401,334.246,405.948,311.793,378.35,311.793z M395.033,395.213 c0,9.2-7.484,16.684-16.684,16.684H133.652c-9.2,0-16.684-7.484-16.684-16.684v-33.368c0-9.2,7.484-16.684,16.684-16.684H378.35 c9.2,0,16.684,7.484,16.684,16.684V395.213z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWax);
export default __webpack_public_path__ + "static/media/wax.a9872a07e81764a90209fae427da1dd5.svg";
export { ForwardRef as ReactComponent };